import axios from "axios";
import React, { useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import PasswordChangedModal from "./modal/PasswordChangedModal";
import {useNavigate } from "react-router-dom";

export default function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { user,dispatch } = useAuthContext();
  const navi = useNavigate();
  const [passwordChangedModal, setPasswordChangedModal] = useState(false);

  const cancelModal = () => {
    setPasswordChangedModal(false)
  }

  const validatePassword = (password) => {
    const passwordRequirements =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRequirements.test(password);
  };

  const handleSubmit = async (e) => {
    setErrorMessage("")
    e.preventDefault();
    setIsLoading(true);
    let err = false;

    try {
      if (
        currentPassword.length == 0 ||
        newPassword.length == 0 ||
        confirmPassword.length == 0
      ) {
        setErrorMessage("All feiled must be filled.");
        err = true;
      }

      if (newPassword !== confirmPassword) {
        setErrorMessage("New passwords do not match.");
        err = true;
      }

      if (!validatePassword(newPassword)) {
        setErrorMessage(
          "Password must be at least 8 characters long and include a lowercase letter, an uppercase letter, a number, and a special character."
        );
        err = true;
      }

      if (!err) {
        const createNewPassword = {
          currentPassword,
          newPassword,
        };

        const changePasswordResponse = await axios.post(
          `${ApiConnectionString}/api/CreateNewPassword`,
          createNewPassword,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (changePasswordResponse.status === 200) {
          setPasswordChangedModal(true)
          setConfirmPassword("")
          setCurrentPassword("")
          setNewPassword("")
        }
      }
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      if (error.response && error.response.status === 400) {
        // Handle specific 400 status error
        setErrorMessage(error.response.data);
      } else {
        // Handle other errors
      }
    } finally {
      setIsLoading(false);
    }
  };
  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div className="container">
        <div className="mx-4">
        <p className="settings-custom-small fw-bold mb-0">Change Password</p>
        <div className="d-flex justify-content-center p-0 m-0">
          <hr className="dashed w-100" />
        </div>
        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
        <form onSubmit={handleSubmit} className="password-form">
          <div className="form-group">
            <label htmlFor="current-password">Current Password:</label>
            <input
              type="password"
              id="current-password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>
          <hr className="dashed w-100" />
          <div className="form-group">
            <label htmlFor="new-password">New Password:</label>
            <input
              type="password"
              id="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <hr className="dashed w-100" />
          <div className="form-group">
            <label htmlFor="confirm-password">Confirm New Password:</label>
            <input
              type="password"
              id="confirm-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-actions">
            <button className="px-3 py-2 saveChanges-button" type="submit">
          Change Password
            </button>
          </div>
        </form>
        {passwordChangedModal && <PasswordChangedModal cancelModal={cancelModal} />}
      </div></div>
    );
  }
}
